import FillImageView from './FillImageView'
import { getProductImageUrl } from '../products/getProductImageUrl'
import { PlaceholderInterface } from '../data/placeholderImages'
import { Chip } from './Chip'
import { Cross } from '../characters'
import React from 'react'
import { BomItem } from '../bom/bomUtils'
import { ListPrice } from '../list/ListPrice'
import { ProductPriceAvailable, ProductPriceUnavailable } from '../productPricing/ProductPricingContext'
import classNames from 'classnames'
import { PriceTypeLabel } from '../list/PriceTypeLabel'
import './ComponentListItemRow.scss'

interface Props {
  bomItem: BomItem
  displayName: string
  description?: string
  price: ProductPriceAvailable | typeof ProductPriceUnavailable
  priceLoading: boolean
  priceTypeLabel: PriceTypeLabel
  topBorder?: boolean
  showPrice: boolean
}

export const ComponentListItemRow: React.FC<Props> = ({
  bomItem,
  displayName,
  price,
  priceLoading,
  priceTypeLabel,
  topBorder,
  description,
  showPrice,
}) => {
  let packSize: number
  let numUsedParts: number

  if (bomItem.packSize > 1) {
    packSize = bomItem.packSize
    numUsedParts = bomItem.individualQuantity
  } else if (bomItem.components.length > 0) {
    // Some bulk packs have a packSize of 1 but we consist of multiple components.
    packSize = bomItem.components.length
    numUsedParts = bomItem.usedComponents.length
  } else {
    packSize = 1
    numUsedParts = 1
  }

  const totalParts = packSize * bomItem.quantity

  return (
    <div className={classNames('ComponentListItemRow', { topBorder })} key={bomItem.itemNo}>
      <div className="imageColumn">
        <FillImageView
          src={getProductImageUrl(bomItem.image) || PlaceholderInterface}
        />
      </div>
      <div className="descriptionColumn">
        <div>
          {description && (<div className="productDescription">{description}</div>)}
          <span className="displayName">{displayName}</span>

          {packSize > 1 && (
            <span className="chipWrapper">
              <Chip outline style={{ margin: '0' }}>{packSize}pk</Chip>
            </span>
          )}
        </div>

        <div className="bulkDescription">
          {bomItem.quantity} {Cross} {packSize}pk
          {packSize > 1 && (
            <span className="muted">(using {numUsedParts} of {totalParts} parts)</span>
          )}
        </div>
      </div>
      <div className="priceColumn">
        <ListPrice
          showPrice={showPrice}
          priceLoading={priceLoading}
          price={price}
          priceTypeLabel={priceTypeLabel}
        />
      </div>
    </div>
  )
}